import { Component, OnInit, Inject, NgModule, Input } from '@angular/core';
import { UserService } from '../../../../shared/services/user.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { Subscription } from 'rxjs/Subscription';
import { CustomerSelectItem } from '../../../setup-equipment/setup-equipment.model';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { UpdateSMUReadingModel, EquipmentSMUHistoryVM } from '../../models/manage-equipment.model';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../app/modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import moment from 'moment';
import { InspectionTypeVM } from '../../../../../app/modules/rope-shovel/models/rope-shovel.model';
import { InterpretationService } from '../../../../../app/modules/interpretation/interpretation.service';
import { RopeShovelService } from '../../../../../app/modules/rope-shovel/rope-shovel.service';
import { Router } from '@angular/router';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-create-ropeshovel-inspection',
  templateUrl: './create-ropeshovel-inspection.component.html',
  styleUrls: ['./create-ropeshovel-inspection.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    //{ provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class CreateRopeshovelInspectionComponent implements OnInit {
  maxDate = new Date();
  _equipmentId:number;
  smuPrechange:number;
  inspectionTypesList:InspectionTypeVM[];
  modelId:number
  Error_:boolean=true;
  SMUValidation:boolean=false;
  propelhrs:number=0;
  InspectionTypeId:number ;
  smu:number
  lastUpdateTime: Date;
  dateOfReading  = new Date();
  saving:boolean=false;
  title:string;
  constructor( private _loading: LoadingService,
    private _user: UserService,private _router: Router,
    public dialogRef: MatDialogRef<CreateRopeshovelInspectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private _rshservice: RopeShovelService,
    private _equipment: ManageEquipmentService,    private _interp: InterpretationService,
    private _notification: NotificationsService,) { }

  ngOnInit() {
   this.title = this.data.title;
    this._equipmentId = this.data.equipmentId;
    this.smuPrechange = this.data.smuPrechange;
   this.modelId=this.data.modelId;
   this.lastUpdateTime = new Date(this.data.lastUpdateTime);

   //this.loadInspectionTypes();
    
  }
  changeLateUpdateTime(lastUpdateTime: any) {
    console.log(lastUpdateTime);
    if (lastUpdateTime != undefined && lastUpdateTime instanceof Date) {
      this.lastUpdateTime = lastUpdateTime;
      console.log("dialog lastupdate time   " + this.lastUpdateTime);
    }

  }
//   loadInspectionTypes(){
//     this._interp.getInspectionTypes(this.modelId).subscribe(res=>{
//       this.inspectionTypesList = res;
//       this.InspectionTypeId = 0;
//     })
// }

onNoClick(): void {
  this.dialogRef.close(false);
}

CheckSMU(){
  if(this.smu< this.smuPrechange){
    this.SMUValidation=true;
    this.Error_=true;
  }else{
    this.Error_=false;
    this.SMUValidation=false;

  }
}


inspectiondate_:string;
CreateNewInspection(){
  this.saving=true;
  const rightDate = new Date(this.dateOfReading);
  this.inspectiondate_ = rightDate.toLocaleDateString('en-US');
this._rshservice.CreateNewRopeShovelInspection(this._equipmentId,this.smu,this.inspectiondate_, this.propelhrs).subscribe(res=>{
  if(res.m_Item1==true){
   this.saving=false;
   this.dialogRef.close(true);
   this._notification.success(res.m_Item2)
   this._router.navigate(['/rs-inspection', res.m_Item3]);
  }else{
    this.saving=false;
   this._notification.error(res.m_Item2)

  }

 
})
}


}
